import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';

import styles from './Advt.module.css';

export const Advt = () => {
  const { title, qrCode1, qrCode2, sizeQR, titleFontSize } = useGetParams();

  const advtlines = title.split(/\\n/);

  return (
    <div className={styles.wrapper}>
      {advtlines && (
        <motion.div
          initial={{ y: '100vh' }}
          animate={{ y: 0 }}
          transition={{ duration: 1 }}
          className={styles.titleBlock}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {advtlines.map((l) => (
            <div key={l} className={styles.title}>
              {l}
            </div>
          ))}
        </motion.div>
      )}

      <div className={styles.qrsWrapper}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 0.6, delay: 1 },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: { duration: 0.6, delay: 1 + 0.3 },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="" />
          </motion.div>
        )}
      </div>
    </div>
  );
};
